(function () {
  'use strict';

  angular.module('sempraWebapp').service('apiService', apiService);

  /** @ngInject */
  function apiService(
    $http,
    $q,
    apiErrorHandlerService,
    sessionData,
    apiMockService,
    $log
  ) {
    var apiHostUrl = '';

    this.init = function (hostUrl) {
      apiHostUrl = hostUrl;
    };

    this.signIn = function (username, password) {
      var deferred = $q.defer();
      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/emailSignIn',
        headers: {
          Accept: 'text/plain, application/vnd.authentication.v2+json'
        },
        data: {
          username: username,
          password: password
        }
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.getWebSocketsToken = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/websocketsToken'
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          apiErrorHandlerService(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.forgotPassword = function (_email, language) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/passwordReset?language=' + language,
        headers: {
          Accept: 'text/plain, application/vnd.resetpassword.v1+json'
        },
        data: {
          email: _email,
          clientType: 'MERCHANT'
        }
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.resetPassword = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/resetPassword/' + data.code,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data.password
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.refreshToken = function () {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        async: false,
        url: apiHostUrl + '/api/refreshToken',
        headers: {
          Accept: 'text/plain, application/vnd.authentication.v2+json'
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.changeUserRole = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees/' + data.userId,
        data: {
          role: data.role,
          adminId: data.adminId
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateUserInfo = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/users/me/',
        headers: { Accept: 'application/vnd.noemail.v1+json' },
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.changePassword = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/users/me/passwordChange',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.addNewUser = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        data: data,
        url: apiHostUrl + '/api/companies/myCompany/facilityAdmins'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    };

    this.deleteUser = function (userId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees/' + userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.activateAccount = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/accountActivation/' + data.activationCode,
        data: data.password
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            'onlyMsg',
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDevices = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/r2wDevices'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDeviceDetails = function (deviceId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/washFacilities/' + deviceId + '/details'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateDeviceDetails = function (deviceId, data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        data: data,
        url: apiHostUrl + '/api/washFacilities/' + deviceId + '/details'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // DON'T ERASE ----------------------------------------------------------------

    // this.getDeviceBySerialNumber = function (serialNumber) {
    //     var deferred = $q.defer();

    //     $http({
    //         method: 'GET',
    //         cache: false,
    //         headers: { 'Accept': 'text/plain, application/json'},
    //         url: apiHostUrl + '/api/devices/' + serialNumber
    //     }).then(function (successData) {
    //         deferred.resolve(successData.data);
    //     }, function (errorData) {
    //         apiErrorHandlerService(errorData.data, errorData.header, errorData.status, deferred);
    //     });

    //     return deferred.promise;
    // };

    // -----------------------------------------------------------------------------

    this.getDeviceBySerialNumber = function (serialNumber) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/r2wDevices/' + serialNumber
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.actuate = function (serialNumber, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/devices/' + serialNumber + '/actuation',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.groupActuate = function (deviceKey, pointId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/devices/' +
          deviceKey +
          '/' +
          pointId +
          '/groupActuation',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getMessages = function (
      deviceKey,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      if (deviceKey) {
        query += '&deviceKey=' + deviceKey;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAlarmMessages = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages/alarms'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.dismissAlarm = function (alarmId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages/alarms/' + alarmId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getKarcherAlarms = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/karcher-alarm/list'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // REPORTS
    this.getDailyFinances = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.dailyturnover.v2+json' },
        url: apiHostUrl + '/api/periodicReports/dailyTurnover'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDailyFinancesBySerialNumber = function (serialNumber) {
      return apiMockService.getDailyFinancesBySerialNumber(serialNumber);
    };

    this.getFinancesByDate = function (
      serialNumber,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalByDate?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalCoinsByDate = function (
      serialNumber,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalCoinsPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalTokenPaymentsByDate = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalTokenPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalTokenCount = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalTokenCount?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalEuroKeyByDate = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalEurokeyPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getLoyaltyTresholds = function (
      campaignId,
      type,
      tresholdValue,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/loyaltyCampaigns/' +
          campaignId +
          '/thresholdReport?from=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          '&threshold=' +
          tresholdValue +
          '&type=' +
          type
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByHours = function (
      serialNumber,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/averageByHour?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByBox = function (
      facilityPointId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/spendingByBox?facilityId=' +
          facilityPointId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByDay = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/averageByDayOfWeek?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getPosIncome = function (
      facilityId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalIncomePOS?facilityId=' +
          facilityId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalR2WByDate = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalOnlinePayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getComparationForPeriod = function (
      deviceSerial,
      fromMonth,
      toMonth,
      fromYear,
      toYear
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/comparativeFacilityReport?facilityId=' +
          deviceSerial +
          '&sinceMonth=' +
          fromMonth +
          '&toMonth=' +
          toMonth +
          '&yearOne=' +
          fromYear +
          '&yearTwo=' +
          toYear
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalByUserGroupsForPeriod = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/usersPerGroup?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getVisitsCountForPeriod = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/usersPerVisitCount?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalSpentLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsSpentByFacility?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalGivenLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsGivenByDay?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalPurchasedLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsSoldByDay?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getChangerIncomePerDate = function (
      facilityId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/changerIncome?facilityId=' +
          facilityId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getLoyaltyPerPaymentMethodForPeriod = function (
      fromTimestamp,
      toTimestamp
    ) {
      return apiMockService.getLoyaltyPerPaymentMethodForPeriod(
        fromTimestamp,
        toTimestamp
      );
    };

    this.sendMessageToCampaignUsers = function (
      campaignId,
      tresholdValue,
      type,
      msg
    ) {
      var deferred = $q.defer();
      $http({
        method: 'POST',
        data: msg,
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/loyaltyCampaigns/' +
          campaignId +
          '/message?threshold=' +
          tresholdValue +
          '&type=' +
          type
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    //sempra users

    this.getCompanyUsers = function (page, pageSize, orderBy, order) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.searchSempraUsers = function (searchTerm) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/users/search',
        data: searchTerm
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.searchSempraUsersByTelephoneNumber = function (searchTerm) {
      return this.searchSempraUsers(searchTerm);
    };

    this.searchSavingsUsers = function (searchTerm) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/savings/users',
        params: { search: searchTerm }
      }).then(
        function (successData) {
          deferred.resolve(successData.data.content || []);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    //end sempra users

    // user groups

    this.getUserGroupById = function (groupId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getUserGroupTypes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroupTypes'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getUserGroups = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getSavingsUserGroups = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups/savings'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getUserGroupSpending = function (groupId, dateFrom, dateTo) {
      var deferred = $q.defer();
      var query = '';
      if (dateFrom && dateTo) {
        query = '?dateFrom=' + dateFrom + '&dateTo=' + dateTo;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups/' + groupId + '/spending' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getUserTransactions = function (groupId, savingsUserId, dateFrom, dateTo) {
      var deferred = $q.defer();
      var query = '';
      if (dateFrom && dateTo) {
        query = '?dateFrom=' + dateFrom + '&dateTo=' + dateTo;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups/' + groupId + '/users/' + encodeURIComponent(savingsUserId) + '/transactions' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTemporalRulePercentage = function (temporalDeviceType) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/r2wDevices/temporalRulePercentage?temporalDeviceType=' +
          temporalDeviceType
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createUserGroup = function (groupName, groupType) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups',
        data: { name: groupName, groupType: groupType || 'DEFAULT' }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateUserGroup = function (groupId, groupName) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId,
        data: groupName
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteUserGroup = function (groupId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // end user groups

    // campaign templates

    this.getCampaignTemplateById = function (campaignTemplateId) {
      return apiMockService.getCampaignTemplateById(campaignTemplateId);
    };

    this.getCampaignTemplates = function () {
      return apiMockService.getCampaignTemplates();
    };

    this.createCampaignTemplate = function (newCampaignTemplate) {
      return apiMockService.createCampaignTemplate(newCampaignTemplate);
    };

    this.updateCampaignTemplate = function (updatedCampaignTemplate) {
      return apiMockService.updateCampaignTemplate(updatedCampaignTemplate);
    };

    this.deleteCampaignTemplate = function (campaignTemplateId) {
      return apiMockService.deleteCampaignTemplate(campaignTemplateId);
    };

    // end campaign templates

    // campaigns

    this.getCampaignById = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getCampaigns = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createCampaign = function (newCampaign) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns',
        data: newCampaign
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateCampaign = function (updatedCampaign) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + updatedCampaign.id,
        data: updatedCampaign
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.activateCampaign = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId + '/status',
        data: true
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteCampaign = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // end campaigns

    this.getUsersForUserGroup = function (groupId, page, pageSize) {
      var deferred = $q.defer(),
        query = '?page=' + page + '&size=' + pageSize;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId + '/memberships' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getActiveUsersForUserGroup = function (
      groupId,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/userGroups/' +
          groupId +
          '/memberships/active' +
          query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.addUserToUserGroup = function (groupId, userId) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId + '/memberships',
        data: userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.removeUserFromUserGroup = function (membershipId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/memberships/' + membershipId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // INVOICES
    // get all invoices by selected year and type

    this.getPeriodicSummary = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/periodicReports/periodicSummary'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getInvoices = function (
      selectedYear,
      selectedType,
      page,
      pageSize,
      orderBy,
      order
    ) {
      orderBy = orderBy.indexOf('-') > -1 ? orderBy.substring(1) : orderBy;

      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&year=' +
          selectedYear +
          '&type=' +
          selectedType +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // SEND INVOICE TO R2W
    this.updateInvoice = function (invoiceId, invoiceNumber, status) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/' + invoiceId + '/' + status, // only payment
        data: invoiceNumber
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GET INVOICE PDF
    this.downloadInvoice = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/pdf',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET B2B SPECIFICATION PDF
    this.downloadB2bSpec = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/b2b',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET B2C SPECIFICATION PDF
    this.downloadB2cSpec = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/b2c',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET BUSINESS TRANSACTIONS
    this.getBusinessTransactions = function (
      sinceMonth,
      toMonth,
      year,
      orderBy,
      order,
      page,
      pageSize
    ) {
      var deferred = $q.defer(),
        query =
          '?sinceMonth=' +
          sinceMonth +
          '&toMonth=' +
          toMonth +
          '&year=' +
          year +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: {
          Accept: 'application/vnd.businessuserexpenses+json'
        },
        url: apiHostUrl + '/api/invoices/expenses' + query
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.headers,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GET BUSINESS INVOICE PDF
    this.downloadBusinessInvoice = function (userId, month, year) {
      var deferred = $q.defer(),
        query = '?userId=' + userId + '&month=' + month + '&year=' + year;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/pdf' + query,
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // NEWS
    this.getCompanyNews = function (page, pageSize, orderBy, order, companyId) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order +
          '&company=' +
          companyId;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteNews = function (newsId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/' + newsId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.saveNews = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GLOBAL NOTICE
    this.getGlobalNotice = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.news.merchant.notice+json' },
        url: apiHostUrl + '/api/news/notice'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createLocalTokens = function (email, amount) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/directTopUp',
        data: {
          email: email,
          amount: amount
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.getVouchersHistory = function (
      page,
      pageSize,
      orderBy,
      order,
      voucherPrefixFilter
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      if (voucherPrefixFilter) {
        query = query + '&codePrefix=' + voucherPrefixFilter;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.vouchersToCSV = function (voucherPrefixFilter) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/csv, application/vnd.voucher.list+json' },
        responseType: 'text',
        url: apiHostUrl + '/api/vouchers?codePrefix=' + voucherPrefixFilter
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createVouchers = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/create',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.createAndRetrieveVouchers = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      console.log('🚀 API Service - Sending expiresInDays:', expireInDays, 'Type:', typeof expireInDays);

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/createAndRetrieve',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.createAndRetrieveVouchersVacc = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/createAndRetrieveVacc',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.createAndRetrieveVouchersJetWash = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/createAndRetrieveJetWash',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.deleteHistory = function () {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/cashHistory'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTransactionsExpenses = function (
      email,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?email=' +
          email +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/expenses' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTransactionsTopUps = function (
      email,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?email=' +
          email +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/locals' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getManagingTokens = function (email) {
      var deferred = $q.defer();

      var encodeEmail = encodeURIComponent(email);

      var query = '?email=' + encodeEmail;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/accountBalances' + query,
        headers: { Accept: 'application/vnd.listvirtual.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteManagingTokens = function (data) {
      var deferred = $q.defer();

      var query = data.accountId + '?amount=' + data.amount;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/accountBalances/' + query,
        headers: { Accept: 'application/vnd.delete.v2+json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.extendManagingTokens = function (data) {
      var deferred = $q.defer();

      var query = data.accountId + '?timestamp=' + data.timestamp;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/accountBalances/' + query,
        headers: { Accept: 'application/vnd.extend.v2+json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getCompanyDetails = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/companies/myCompany',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRegionById = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/regions/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Pricing

    this.getCompanyTokenPackage = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingleCompanyTokenPackage = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createCompanyTokenPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage',
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateCompanyTokenPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + data.id,
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteCompanyTokenPackage = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingeWashes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingeWash = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createSingeWash = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash?price=' + data.price,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateSingeWash = function (data) {
      var deferred = $q.defer();

      var query = '?price=' + data.price;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + data.id + query,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteSingeWash = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Savings Packages

    this.getCompanySavingsPackages = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companySavingsPackage',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createCompanySavingsPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/prices/companySavingsPackage',
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateCompanySavingsPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/prices/companySavingsPackage/' + data.id,
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteCompanySavingsPackage = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/prices/companySavingsPackage/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Working hours

    this.getDeviceWorkingHours = function (pointId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/facilityWorkingSchedule/' + pointId,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateDeviceWorkingHours = function (pointId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/facilityWorkingSchedule/' + pointId,
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // ORGANIZATIONS
    this.getOrganizationsListByType = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getOrganizationById = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + organizationId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSupportedOrganizationList = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl +
          '/api/merchant-organizations/' +
          organizationId +
          '/support',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createChildOrganization = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateChildOrganization = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + data.id,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteOrganization = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + organizationId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getForUserOrganizationListByUserId = function (userId) {
      var deferred = $q.defer(),
        paramUrl = userId
          ? '/api/merchant-organizations/userOrganization/' +
            userId +
            '/organizations'
          : '/api/merchant-organizations/userOrganization/organizations';
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + paramUrl,
        headers: { Accept: 'text/plain, application/vnd.organizations.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getForUserCreateOrganizationList = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/userOrganization/list',
        headers: {
          Accept: 'text/plain, application/vnd.user.organizations.v1+json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createUserForSelectedOrganizationAndRole = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/userOrganization',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateUserForSelectedOrganizationAndRole = function (userId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url:
          apiHostUrl + '/api/merchant-organizations/userOrganization/' + userId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.resendVerificationMail = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant/verificationMail',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getOrganizationUsers = function (email, page, pageSize, orderBy, order) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: {
          Accept: 'text/plain, application/vnd.user.organizations.v1+json'
        },
        url: apiHostUrl + '/api/merchant-organizations/userOrganization/list',
        params: {
          email: email,
          page: page,
          size: pageSize,
          sort: orderBy + ',' + order
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(
            err.data,
            err.headers,
            err.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };



    this.getOrganizationUserById = function (userId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/merchant-organizations/userOrganization/' + userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteOrganizationUser = function (userId, organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url:
          apiHostUrl +
          '/api/merchant-organizations/userOrganization/' +
          userId +
          '/' +
          organizationId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Use only for create organization
    this.getAllCompaniesShort = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/companies/organizations/' + organizationId + '/list',
        headers: { Accept: 'text/plain, application/vnd.companyshort.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllRegionsShort = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/regions/list',
        headers: { Accept: 'text/plain, application/vnd.regionshort.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllSitesShort = function (organizationId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/organizations/' + organizationId + '/list',
        headers: { Accept: 'text/plain, application/vnd.all.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Karcher - Dashboard
    this.getKarcherSitesData = function (siteName, alarmStatus) {
      var deferred = $q.defer();
      var query = '?siteName=' + siteName + '&statuses=' + alarmStatus;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites' + query,
        headers: { Accept: 'text/plain, application/vnd.overview.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherSitesInfoWindowData = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherSiteDetailsById = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId + '/devices',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherFaultsByDeviceId = function (deviceId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/' + deviceId + '/faults',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherDeviceDetailsById = function (siteId, deviceId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl + '/api/merchantSites/' + siteId + '/devices/' + deviceId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverPrograms = function (washFacilityId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/' + washFacilityId + '/programs',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverProgramsBySite = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/site/' + siteId + '/programs',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverProgramOptions = function (deviceId, programId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/' + deviceId + '/programs/' + programId + '/options',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverSalesTypes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/sales-types',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllRolloverSalesTypes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/sales-types/all',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateRolloverSalesType = function (salesTypeData) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/rollover/sales-types/' + salesTypeData.id,
        data: salesTypeData,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createRolloverVoucher = function (voucherData) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/rollover/vouchers',
        data: voucherData,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverVouchersBySite = function (siteId, page, pageSize, search) {
      var deferred = $q.defer();

      var params = {
        page: page || 0,
        size: pageSize || 10
      };
      if (search) {
        params.search = search;
      }

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/site/' + siteId + '/vouchers',
        params: params,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverVoucherRedeems = function (voucherId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/voucher/' + voucherId + '/redeems',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deactivateRolloverVoucher = function (voucherId) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/rollover/vouchers/' + voucherId + '/deactivate',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Rollover statistics -- COMMENTED OUT
    // this.getRolloverStatistics = function (siteId, dateFrom, dateTo) {
    //   var deferred = $q.defer();
    //   var params = [];
    //   if (dateFrom) params.push('since=' + encodeURIComponent(dateFrom));
    //   if (dateTo) params.push('until=' + encodeURIComponent(dateTo));
    //   var query = params.length > 0 ? '?' + params.join('&') : '';

    //   $http({
    //     method: 'GET',
    //     cache: false,
    //     url: apiHostUrl + '/api/rollover/site/' + siteId + '/statistics' + query,
    //     headers: { Accept: 'text/plain, application/json' }
    //   }).then(
    //     function (res) {
    //       deferred.resolve(res.data);
    //     },
    //     function (err) {
    //       apiErrorHandlerService(err.data, err.headers, err.status, deferred);
    //     }
    //   );

    //   return deferred.promise;
    // };

    this.getRolloverSiteOptions = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/site/' + siteId + '/options',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRolloverExecutedWashes = function (siteId, dateFrom, dateTo) {
      var deferred = $q.defer();
      var params = [];
      if (dateFrom) params.push('since=' + encodeURIComponent(dateFrom));
      if (dateTo) params.push('until=' + encodeURIComponent(dateTo));
      var query = params.length > 0 ? '?' + params.join('&') : '';

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/rollover/site/' + siteId + '/executed-washes' + query,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Rollover voucher stats -- COMMENTED OUT
    // this.getRolloverVoucherStats = function (siteId, since, to, timeUnit) {
    //   var deferred = $q.defer();
    //   var query = '?since=' + since + '&to=' + to + '&timeUnit=' + (timeUnit || 'DAY');

    //   $http({
    //     method: 'GET',
    //     cache: false,
    //     url: apiHostUrl + '/api/rollover/site/' + siteId + '/stats' + query,
    //     headers: { Accept: 'text/plain, application/json' }
    //   }).then(
    //     function (res) {
    //       deferred.resolve(res.data);
    //     },
    //     function (err) {
    //       apiErrorHandlerService(err.data, err.headers, err.status, deferred);
    //     }
    //   );

    //   return deferred.promise;
    // };

    // Karcher alarms (messages)
    this.getKarcherSiteAlarmList = function (
      filter,
      faultStatus,
      facilityId,
      siteIds,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&faultStatus=' +
          faultStatus +
          '&washFacilityId=' +
          facilityId +
          siteIds +
          '&from=' +
          from +
          '&to=' +
          to +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm' + query,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Changer alarms
    this.getChangerAlarms = function (washFacilityId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/changer/' + washFacilityId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Karcher alarms history (messages)
    this.getKarcherAlarmsHistoryList = function (
      filter,
      facilityId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&from=' +
          from +
          '&to=' +
          to +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl + '/api/karcher-alarm/' + facilityId + '/history' + query,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherAlarmSubscriptions = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createAlarmSubscription = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.unsubscribeKarcherAlert = function (siteId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions/' + siteId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllSitesForExactUser = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/list',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Cashless Payment and Refund
    this.getCashlessSales = function (
      filter,
      since,
      until,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&filter=' +
          filter +
          '&since=' +
          since +
          '&until=' +
          until +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getCashlessSalesExportCSV = function (
      filter,
      since,
      until
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&since=' +
          since +
          '&until=' +
          until;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales/exportCSV' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.refundCashlessPayment = function (id, amount) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url:
          apiHostUrl + '/api/cashlessSales/' + id + '/refund?amount=' + amount,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getCashlessTotals = function (since, until, filter) {
      var deferred = $q.defer(),
        query = '?since=' + since + '&until=' + until + '&filter=' + filter;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales/total' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // FOR KARCHER REPORTS REQUIRED APIS
    this.getWashFacilityBoxesByWashFacilityId = function (washFacilityId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url:
          apiHostUrl +
          '/api/washFacilities/' +
          washFacilityId +
          '/washFacilityBoxes'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getWashFacilityShortList = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/washFacilities/accessible'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // KARCHER REPORTS
    this.getJetwashReportTurnoverPerBay = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/turnoverPerBay' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getJetwashReportTurnoverPerChannel = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&bayId=' +
          data.bayId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/turnoverPerChannel' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getJetwashReportWorkingHoursPerProgram = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&bayId=' +
          data.bayId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/workingHoursPerProgram' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getRolloverReportWashesPerProgram = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&type=' +
          data.type +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/rollover/washesPerProgram' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getRolloverReportTurnover = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/rollover/turnover' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getHistoryOfActuatedPointsByDeviceKey = function (
      deviceKey,
      pointIds,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          pointIds +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/devices/' +
          deviceKey +
          '/actuators/history' +
          query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getPointsListByDeviceKey = function (deviceKey) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/points/device/' + deviceKey + '/actuators'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // WEATHER API
    this.getCurrentWeather = function (latitude, longitude) {
      var deferred = $q.defer(),
        weatherApiKey = 'c88952ff3c1743289b0134557231406',
        query = '?q=' + latitude + ', ' + longitude + '&key=' + weatherApiKey;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: 'https://api.weatherapi.com/v1/current.json' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    };

    this.getHistoryWeather = function (latitude, longitude, from, to) {
      var deferred = $q.defer(),
        weatherApiKey = 'c88952ff3c1743289b0134557231406',
        query =
          '?q=' +
          latitude +
          ', ' +
          longitude +
          '&dt=' +
          from +
          '&end_dt=' +
          to +
          '&key=' +
          weatherApiKey;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: 'https://api.weatherapi.com/v1/history.json' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    };

    // SITE WORKING SCHEDULES AND HOLIDAYS

    this.getSiteHolidays = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/siteholiday/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createSiteHolidays = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateSiteHolidays = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteSiteHolidays = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteHoliday = function (siteId, holidayId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url:
          apiHostUrl +
          '/api/siteholiday/' +
          siteId +
          '/siteHoliday/' +
          holidayId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getWorkingSchedules = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateWorkingSchedules = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.propagateWorkingSchedules = function (siteId, path) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId + '/propagate' + path,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getReleaseNotes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/release-notes'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // API FOR ORGANIZATIONS TYPES BY ID
    this.getOrganizationsCompanyById = function (companyId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateOrganizationVoucherExpirationDays = function (companyId,voucherExpirationDays) {
      var deferred = $q.defer();

      $http({
        method: 'PATCH',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId + '/voucherExpirationDays',
        data: {
          days: voucherExpirationDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateOrganizationRolloverVoucherExpirationDays = function (companyId, rolloverVoucherExpirationDays) {
      var deferred = $q.defer();

      $http({
        method: 'PATCH',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId + '/rolloverVoucherExpirationDays',
        data: {
          days: rolloverVoucherExpirationDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateOrganizationSavingsExpirationDays = function (companyId, savingsExpirationDays) {
      var deferred = $q.defer();

      $http({
        method: 'PATCH',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId + '/savingsExpirationDays',
        data: {
          days: savingsExpirationDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // Get events list for selected device - used on device details page, Karcher brand
    this.getEventsListForSelectedDevice = function (deviceKey) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/devices/' + deviceKey + '/pullRequest/events'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // Report builder (dynamic reports)

    this.getAllReportConfigurations = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/reports/dynamic/configuration'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getSelectedReportConfiguration = function (configurationId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/reports/dynamic/configuration/' + configurationId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteReportsData = function (companyId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/reports/transaction/' + companyId + '/cache'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.executeDynamicReport = function (configurationId, data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/reports/dynamic/report/' + configurationId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // SITES DETAILS

    this.getSiteDetailsById = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.site.overview.v2+json' },
        url:
          apiHostUrl + '/api/merchantSites/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateSiteDetails = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId,
        headers: {
          Accept: 'application/vnd.site.update.v2+json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET TERMS OF SERVICE DOCUMENT

    this.getTermsOfServiceDocument = function (isoCode, language) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/html' },
        url:
          apiHostUrl +
          '/api/termsAndConditions/document/merchant?countryIsoCode=' + isoCode + '&locale=' + language
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.acceptTermsOfServiceDocument = function () {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/termsAndConditions/accept/merchant',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET SESSION AND ACTIVATE SERVICE ON DEVICES

    this.createDeviceSession = function (boxPointId) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/points/' + boxPointId + '/sessions',
        headers: {
          Accept: 'application/vnd.session.v1+json'
        }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.startDeviceService = function (facilityId, boxPointId, token) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/washFacilities/admin/' + facilityId + '/boxes/' + boxPointId + '/activation',
        headers: {
          Accept: 'application/json'
        },
        data: token
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.changeDeviceLabelName = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/points/label',
        headers: {
          Accept: 'application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Savings Users API
    this.getSavingsUsers = function (page, pageSize, orderBy, order, search) {
      var deferred = $q.defer();
      var query = '?page=' + (page - 1) + '&size=' + pageSize;

      if (search) {
        query = query + '&search=' + encodeURIComponent(search);
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/savings/users' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deactivateSavingsAccount = function (accountId) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/savings/accounts/' + accountId + '/deactivate'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createSavingsAccount = function (savingsData) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        url: apiHostUrl + '/api/savings/accounts',
        data: savingsData
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getSavingsAccount = function (accountId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/savings/accounts/' + accountId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.editSavingsAccount = function (accountId, savingsData) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        url: apiHostUrl + '/api/savings/accounts/' + accountId,
        data: savingsData
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // Savings reports -- COMMENTED OUT
    // this.getSavingsReports = function (dateFrom, dateTo, timeFrame) {
    //   var deferred = $q.defer();
    //   var query = '?dateFrom=' + dateFrom + '&dateTo=' + dateTo + '&timeFrame=' + timeFrame;

    //   $http({
    //     method: 'GET',
    //     cache: false,
    //     headers: { Accept: 'application/json' },
    //     url: apiHostUrl + '/api/savings/reports' + query
    //   }).then(
    //     function (successData) {
    //       deferred.resolve(successData.data);
    //     },
    //     function (errorData) {
    //       apiErrorHandlerService(
    //         errorData.data,
    //         errorData.header,
    //         errorData.status,
    //         deferred
    //       );
    //     }
    //   );

    //   return deferred.promise;
    // };

    this.getMyCompanyOptionalFeatures = function (companyId) {
      var deferred = $q.defer();
      var url = apiHostUrl + '/api/companies/myCompany/optionalFeatures';
      var headers = { Accept: 'application/json' };

      if (companyId) {
        headers.Accept = 'application/vnd.optionalfeatures.v2+json';
        url += '?companyId=' + companyId;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: headers,
        url: url
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getMoneyChangerJournalEntries = function (
      siteId,
      facilityId,
      deviceKey,
      fromTimestamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      var query =
        '?since=' + fromTimestamp +
        '&to=' + toTimestamp +
        '&page=' + page +
        '&size=' + pageSize +
        '&sort=' + orderBy + ',' + order;

      if (siteId) {
        query += '&siteId=' + siteId;
      }
      if (facilityId) {
        query += '&facilityId=' + facilityId;
      }
      if (deviceKey) {
        query += '&deviceKey=' + encodeURIComponent(deviceKey);
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/moneyChangerJournal' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getMoneyChangerJournalChangers = function (siteId) {
      var deferred = $q.defer();
      var query = siteId ? '?siteId=' + siteId : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/moneyChangerJournal/changers' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

  }
})();
